// src/components/Offer.jsx
import React from "react";
import "./Offer.css";

function Offer() {
  return (
    <section id="offer" className="section section-bg">
      <div className="container">
        <div className="section-title">
          <h2>Moja Oferta</h2>
        </div>
        <div className="offer-grid">
          <div className="offer-card">
            <h3>Egzamin Ósmoklasisty</h3>
            <p>
              Kompleksowe przygotowanie, które zapewni spokój i wysoki wynik.
              Przerobimy wszystkie typy zadań.
            </p>
          </div>
          <div className="offer-card">
            <h3>Matura</h3>
            <p>
              Skuteczny kurs, który pozwoli Ci bez stresu zdać maturę na
              satysfakcjonującym poziomie.
            </p>
          </div>
          <div className="offer-card">
            <h3>Przygotowanie do lekcji</h3>
            <p>
              Skupimy się na zagadnieniach sprawiających problemy i przećwiczymy różne typy zadań aby nic cię nie zaskoczyło.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Offer;